import { useCallback, useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// Bouton « Synchroniser maintenant » (admin) : rattrape J-1 sans attendre le cron de 02:00.
export const InpulseSyncNow = ({ onDone, className = "" }) => {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const wasActive = useRef(false);
  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/integrations/inpulse/sync-now"); setSt(data); return data; } catch { return null; }
  }, []);
  useEffect(() => { if (user?.role === "admin") refresh(); }, [user, refresh]);
  useEffect(() => {
    const active = !!st?.active_job;
    if (active) wasActive.current = true;
    if (!active && wasActive.current) { wasActive.current = false; toast.success("Synchronisation Inpulse terminée"); onDone?.(); }
    if (!active) return;
    const t = setInterval(refresh, 5000); return () => clearInterval(t);
  }, [st?.active_job, refresh, onDone]);
  if (user?.role !== "admin") return null;
  const active = !!st?.active_job;
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/integrations/inpulse/sync-now"); toast.success(data.message); setTimeout(refresh, 800); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="inpulse-sync-now">
      <button type="button" onClick={run} disabled={busy || active} data-testid="inpulse-sync-now-btn"
        className="inline-flex items-center gap-1.5 rounded-full border border-emerald-300 bg-emerald-50 px-3 py-1 text-[11px] font-semibold text-emerald-800 transition-colors hover:bg-emerald-100 disabled:opacity-60">
        <RefreshCw className={`h-3.5 w-3.5 ${active ? "animate-spin" : ""}`} />
        {active ? "Synchronisation en cours…" : "Synchroniser maintenant"}
      </button>
      {st && !active && (
        <span className="text-[11px] text-slate-500" data-testid="inpulse-sync-now-info">
          {st.missing_days > 0 ? `${st.missing_days} jour(s) à rattraper (données jusqu'au ${st.data_until})` : `À jour (J-1 : ${st.j1})`}
        </span>
      )}
    </div>
  );
};
